const heroBlock = document.querySelectorAll('.block-hero');

if (heroBlock.length > 0) {
  import('animejs').then(({ default: anime }) => {
    heroBlock.forEach(block => {
      /**
       *
       * Animation
       *
       */

      let textWrappers = block.querySelectorAll('.title');
      for (var i = 0; i < textWrappers.length; i++) {
        let string = textWrappers[i].textContent
          .split(' ')
          .map(el => {
            return el.replace(/\S/g, "<span class='letter'>$&</span>");
          })
          .join('</span> <span class="word">');

        string = '<span class="word">' + string;
        string = string + '</span>';

        textWrappers[i].innerHTML = string;
      }

      anime
        .timeline({ loop: false })
        .add({
          targets: '.block-hero .title',
          translateX: 0,
          translateY: [-50, 0],
          translateZ: 0,
          opacity: [0, 1],
          easing: 'easeOutSine',
          duration: 600,
          begin: function(anim) {
            for (var i = 0; i < textWrappers.length; i++) {
              textWrappers[i].style.opacity = 1;
            }
          },
        })
        .add(
          {
            targets: '.block-hero .title .letter',
            translateX: 0,
            translateY: [-20, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: 'easeOutSine',
            duration: 300,
            delay: (el, i) => 0 + 30 * i,
          },
          '-=600'
        )
        .add({
          targets: '.block-hero .button',
          translateX: 0,
          translateY: [-20, 0],
          translateZ: 0,
          opacity: [0, 1],
          easing: 'easeOutSine',
          duration: 300,
        });
    });
  });
}
